import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import * as moment from 'moment';
import translate from '../../commonComponents/translate';
import Anchor from '../../commonComponents/Anchor';
import SessionProp from './propTypes/sessionProp';
import AcademyFooterContainer from '../../commonComponents/container/AcademyFooterContainer';
import MarkerIcon from '../../commonComponents/icons/MarkerIcon';
import UserBannerCard from '../../commonComponents/users/UserBannerCard';

function SessionsCarouselItem({ t, className, session }) {
  const { startDate: sessionStartDate, endDate: sessionEndDate, host, type } = session;
  const image = session.imageSquare || session.image;
  const imageURL = image && image.thumb ? image.thumb : '/images/no_image_upload.png';

  const containerClass = cx(
    'm-portlet',
    'm-portlet--rounded',
    'm-portlet--rounded-force',
    'academy-course-item',
    'academy-enrolled-course-item',
    'my-session-list-wrapper ',
    className,
  );

  // Start and End Date
  let startDate = null;
  let endDate = null;
  if (sessionStartDate && sessionEndDate) {
    startDate = moment(sessionStartDate).format('DD MMM, YYYY HH:mm');
    endDate = moment(sessionEndDate).format('DD MMM, YYYY HH:mm');
  }
  const duration = startDate?.length > 0 && endDate?.length > 0;

  return (
    <div className={containerClass}>
      <div className="my-session-list">
        <div className="img-rectangular_session">
          <img
            itemProp="image"
            content={imageURL}
            src={imageURL}
            alt={session.name}
          />
        </div>
        <div className="body-card_session">
          <div className="session-name">
            <h5 className="title-card_session">
              {session.name}
            </h5>
          </div>
          <div className="session-info">
            {host && <UserBannerCard user={host} label={t('sessions_host')} />}
            {type && <AcademyFooterContainer customIcon={<MarkerIcon />} text={t(`sessions_${type}`)} />}
            {duration > 0 && (
              <AcademyFooterContainer
                faIcon="la la-clock-o"
                text={duration ? (
                  <>
                    <div>{startDate}</div>
                    <div>{endDate}</div>
                  </>
                ) : ''}
              />)
            }
          </div>
          <div className="session-actions">
            <Anchor
              href={`/academy/sessions/${session.slug}`}
              className="btn m-btn--pill btn-dynamic navigation-button"
            >
              {t('sessions_openSession')}
            </Anchor>
          </div>
        </div>
      </div>
    </div>
  );
}

SessionsCarouselItem.propTypes = {
  t: PropTypes.func.isRequired,
  className: PropTypes.string,
  session: PropTypes.shape(SessionProp.propType).isRequired,
};

SessionsCarouselItem.defaultProps = {
  className: '',
};

export default translate(SessionsCarouselItem);
